import { inject, Injectable } from '@angular/core';
import { JsonApiResourceMapper, ResourceCollection, ResourceIdentifierMapperService, ResourceMapper, ResourceTypes } from '@big-direkt/json-api-client';
import { ParagraphModel, ParagraphTypes } from '@big-direkt/utils/shared';
import { TwoColumnedParagraphsComponentModel } from './two-columned-paragraphs.model';
import { TwoColumnedParagraphsResource } from './two-columned-paragraphs.resource';

@Injectable({
    providedIn: 'root',
})
@JsonApiResourceMapper
export class TwoColumnedParagraphsMapper extends ResourceMapper<TwoColumnedParagraphsComponentModel> {
    public static override readonly type: ResourceTypes = ResourceTypes.ParagraphBigTwoColColumnedParagraphs;

    private readonly resourceIdentifierMapper = inject(ResourceIdentifierMapperService);

    public map(resource: TwoColumnedParagraphsResource, collection: ResourceCollection): TwoColumnedParagraphsComponentModel {

        return {
            type: ParagraphTypes.TwoColumnedParagraphs,
            mobileStartColumn: resource.attributes.mobile_start_column,
            leftColumn: this.mapParagraphs(this.resourceIdentifierMapper.mapMultiple(resource.relationships.content_left.data, collection) ?? []),
            rightColumn: this.mapParagraphs(this.resourceIdentifierMapper.mapMultiple(resource.relationships.content_right.data, collection) ?? []),
        };
    }

    private mapParagraphs(paragraphs: ParagraphModel[]): ParagraphModel[] {
        return paragraphs.map(paragraph => {
            paragraph.fullWidth = true;

            return paragraph;
        });
    }
}
